import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './NotificationSkeletonCardAtom.scss';

export interface NotificationSkeletonCardAtomProps {
  count?: number;
  className?: string;
}

/**
 * NotificationSkeletonCardAtom - Loading skeleton for notification cards
 * Based on SphereChatPanel's SkeletonMessage component (lines 262-282)
 */
const NotificationSkeletonCardAtom: React.FC<NotificationSkeletonCardAtomProps> = ({
  count = 3,
  className = ''
}) => {
  const skeletons = Array.from({ length: count }, (_, index) => (
    <div key={index} className={`notification-skeleton-card ${className}`}>
      <div className="notification-skeleton-header">
        <Skeleton shape="circle" size="40px" />
        <div className="notification-skeleton-title-section">
          <Skeleton width="60%" height="1rem" />
          <Skeleton width="40%" height="0.8rem" />
        </div>
        <Skeleton width="4rem" height="0.8rem" />
      </div>
      <div className="notification-skeleton-content">
        <Skeleton width="100%" height="0.8rem" />
        <Skeleton width="80%" height="0.8rem" />
      </div>
      <div className="notification-skeleton-footer">
        <Skeleton width="6rem" height="0.75rem" />
      </div>
    </div>
  ));

  return <>{skeletons}</>;
};

export default NotificationSkeletonCardAtom;